<template>
  <div class="slider" ref="slider">
    <vue-scroll
      ref="scroller"
      class="vue-scroll"
      :ops="options"
      @handle-scroll="handleScroll"
      @handle-scroll-complete="handleScrollComplete"
      @mousewheel="onMouseWheel"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
    >
      <div class="slider-content">
        <slot/>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
  import { soundList, soundPlayer } from '../utils/sounds';

  export default {
    data() {
      return {
        options: {
          vuescroll: {
            mode: 'slide',
            sizeStrategy: 'number',
            zooming: false,
            locking: true,
            scroller: {
              boucing: false,
              disable: true,
            },
          },
          scrollPanel: {
            scrollingX: false,
            scrollingY: true,
          },
          bar: {
            opacity: 0,
            disable: true,
          },
        },
        isSwipeSoundPlaying: false,
        isScrolling: false,
        isHorizontalScroll: true,
        lastScrollIndex: 0,
        lastTouchIndex: null,
      };
    },
    methods: {
      onResize() {
        this.isHorizontalScroll = window.matchMedia('(orientation: landscape)').matches;

        this.options.scrollPanel.scrollingX = this.isHorizontalScroll;
        this.options.scrollPanel.scrollingY = !this.isHorizontalScroll;

        this.$nextTick(() => {
          this.$refs.scroller.refresh();
        });
      },
      onMouseWheel(event) {
        this.scrollHorizontally(event.deltaX);
        this.scrollVertically(event.deltaY);
      },
      onTouchStart() {
        this.lastTouchIndex = null;
      },
      onTouchMove(event) {
        const currentTouchIndex = this.options.scrollPanel.scrollingY ? event.touches[0].clientY : event.touches[0].clientX;
        if (!this.isSwipeSoundPlaying && this.lastTouchIndex != null) {
          if (currentTouchIndex > this.lastTouchIndex) {
            // Reverse
            this.isSwipeSoundPlaying = true;
            soundPlayer(soundList.swipeRight, this.onSoundEnd);
          } else if (currentTouchIndex < this.lastTouchIndex) {
            // Forward
            this.isSwipeSoundPlaying = true;
            soundPlayer(soundList.swipeLeft, this.onSoundEnd);
          }
        }

        this.lastTouchIndex = currentTouchIndex;
      },
      onTouchEnd() {
        this.lastTouchIndex = null;
      },
      scrollHorizontally(deltaX) {
        this.$refs.scroller.scrollBy({ dx: deltaX, dy: 0 }, false);
      },
      scrollVertically(deltaY) {
        this.$refs.scroller.scrollBy({ dx: 0, dy: deltaY }, false);
      },
      handleScroll(vertical, horizontal) {
        let isScrollProcessComplete;
        if (this.isHorizontalScroll) {
          isScrollProcessComplete = horizontal.process === 1 || horizontal.process <= 0;
        } else {
          isScrollProcessComplete = vertical.process === 1 || vertical.process <= 0;
        }

        const currentScrollIndex = this.isHorizontalScroll ? horizontal.scrollLeft : vertical.scrollTop;
        const currentScrollDirection = (this.lastScrollIndex === currentScrollIndex || isScrollProcessComplete) ? null : this.lastScrollIndex > currentScrollIndex ? 'reverse' : 'forward';
        this.isScrolling = currentScrollDirection != null;
        this.$emit('scroll', { vertical, horizontal, currentScrollDirection, isScrolling: this.isScrolling });

        this.lastScrollIndex = currentScrollIndex;
      },
      handleScrollComplete(vertical, horizontal) {
        this.isScrolling = false;
        this.$emit('scroll-complete', { vertical, horizontal });
      },
      onSoundEnd() {
        this.isSwipeSoundPlaying = false;
      },
    },
    created() {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    },
    destroyed() {
      window.removeEventListener('resize', this.onResize);
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  .slider {
    height: 100%;

    .vue-scroll > div {
      height: 100%;
    }

    .slider-content {
      align-content: flex-start;
      align-items: flex-start;
      display: flex;
      height: 100%;
      gap: 15px;
      padding-inline: 20px;

      @media (orientation: portrait) {
        flex-flow: column nowrap;
        align-items: center;
      }
      @media (orientation: portrait) and (min-width: $breakpoint-md) {
        padding-block: 30px;
        gap: 30px;
      }
      @media (max-width: $breakpoint-xs) {
        padding-block: 20px;
      }
      @media (orientation: landscape) {
        flex-flow: row nowrap;
        align-items: center;
        
        @media (min-width: $breakpoint-md) {
          gap: 15px;
        }
        @media (min-width: $breakpoint-lg) {
          gap: 25px;
          &.folder-slider {
            gap: 20px;
          }
        }
        @media (max-width: $breakpoint-sm) {
          gap: 15px;
        }
      }
    }
  }
</style>

<style lang="scss">
  .vue-scroll > .__panel.__slide {
    height: 100%;
  }
</style>
